/**
 * MY — Beneficial Owner Notices (Section 60C, M32108) Register Detail 매핑.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32108', {
  title: 'Beneficial Owner Notices (Section 60C) Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo'] },
    { label: 'Notice Date', key: ['presetForm.noticeDate', 'presetForm.state.values.notice_date', 'notice_date'] },
    { label: 'Member Name', key: ['presetForm.memberName', 'presetForm.state.values.member_name', 'member_name'] },
    { label: 'Beneficial Owner', key: ['presetForm.boName', 'presetForm.state.values.bo_name', 'bo_name'] },
  ],
});
